<template>
<v-row justify="center" wrap>
  <v-col class="py-0">
    <div class="px-2">
      <DisplayField label="Client's Annualized Premium" type="currency" :value="client.annualizedPremium" />
    </div>
  </v-col>
  <v-col cols="12" class="py-1">
    <PolicySummaryList />
  </v-col>
  <v-col cols="12">
    <PolicySummaryList inactive />
  </v-col>
  <v-col cols="12">
    <PolicySummaryList archived />
  </v-col>
</v-row>
</template>

<style>
</style>

<script>
import PolicySummaryList from '@/components/Client/Policies/PolicySummaryList.vue';
import DisplayField from '@/components/Shared/DisplayField.vue';
import { mapState } from 'vuex';

export default {
  name: 'Policies',
  components: {
    DisplayField,
    PolicySummaryList
  },
  computed: {
    ...mapState(['client'])
  }
};
</script>
